import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "@studio-freight/lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Catalogo from "@/pages/Catalogo";
import Disena from "@/pages/Disena";
import Proceso from "@/pages/Proceso";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Contacto from "@/pages/Contacto";
import Tablero from "@/pages/Tablero";
import Hamburguesa from "@/pages/Hamburguesa";
import PizzaGame from "@/pages/Pizza";
import Retos from "@/pages/Retos";
import Galeria from "@/pages/Galeria";

const ScrollTop = () => {
  const { pathname } = useLocation();
  const prev = useRef(pathname);
  useEffect(() => {
    const sameCatalog = pathname.startsWith("/catalogo") && prev.current.startsWith("/catalogo");
    prev.current = pathname;
    if (sameCatalog) return;
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true, force: true });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    return () => { lenis.destroy(); delete window.__lenis; };
  }, []);

  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <ScrollTop />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalogo />} />
            <Route path="/catalogo/:slug" element={<Catalogo />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/tablero" element={<Tablero />} />
            <Route path="/hamburguesa" element={<Hamburguesa />} />
            <Route path="/pizza" element={<PizzaGame />} />
            <Route path="/retos" element={<Retos />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/disena" element={<Disena />} />
            <Route path="/proceso" element={<Proceso />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/pago/exito" element={<PaymentSuccess />} />
            <Route path="/pago/cancelado" element={<PaymentCancel />} />
          </Routes>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
